export default {
  noExportSettings: 'Żaden z bloków tego raportu nie wymaga ustawień do eksportu.',
};
